var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"banner experian active cf alert\"><img" + (jade.attr("src", require("./logo.png"), true, true)) + " width=\"181\" alt=\"\"><div class=\"info\"><h2>Want to order credit reports?</h2><p>To be able to request credit reports, you must first verify your identity with Transunion SmartMove.</p><div class=\"butt-container\"><a href=\"#\" style=\"text-decoration: none;\" data-dismiss=\"alert\" class=\"notnow\">Not Now</a><a href=\"#\" ui-sref=\"root.verifications.disclaimer({context: 'landlord', vendor: 'smartmove'})\" class=\"getstarted\">Get Started</a></div></div><div class=\"estimate\"><h3>Estimate: 1 Minute</h3></div><a href=\"#\" data-dismiss=\"alert\" class=\"closeit\"></a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/rspSignupPrompts/report_source_profiles/smartmove/smartmove.jade
// module id = 475
// module chunks = 0